var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations, octopusFeatures) {
    pluginRegistry.registerDeploymentAction("Octopus.DockerRun", function(octopusRepository) {
        return {
            executionLocation: actionExecutionLocations.alwaysOnTarget,
            canHaveChildren: function(){return false;},
            canBeChild: false,
            canChooseRoles: true,
            canShow: function() { return octopusFeatures.isEnabled('IsDockerEnabled'); },
            hasPackages: function(action) { return false; },
            summaryTemplateUrl: "areas/projects/actions/docker_run/Octopus.DockerRun_summary.html",
            editTemplateUrl: "areas/projects/actions/docker_run/Octopus.DockerRun_edit.html",

            preLink: function(vm) {
                vm.networkTypes = {
                    "": {
                        name: "",
                        description: ""
                    },
                    "none": {
                        name: "None",
                        description: "No networking."
                    },
                    "bridge": {
                        name: "Bridge (Linux Default)",
                        description: "Connect the container to the bridge via veth interfaces."
                    },
                    "host": {
                        name: "Host",
                        description: "Use the host's network stack inside the container."
                    },
                    "container": {
                        name: "Container",
                        description: "Use the network stack of another container, specified via its *name* or *id*."
                    },
                    "network": {
                        name: "Custom Network",
                        description: "Connects the container to a user created network."
                    }
                };

                if (!vm.action.Properties["Octopus.Action.Docker.NetworkType"]) {
                    vm.action.Properties["Octopus.Action.Docker.NetworkType"] = "";
                }

                vm.restartPolicies = {
                    "no": {
                        name: "No (Default)",
                        description: "Do not automatically restart the container when it exits. This is the default."
                    },
                    "on-failure": {
                        name: "On Failure",
                        description: "Restart only if the container exits with a non-zero exit status. " +
                        "Optionally, limit the number of restart retries the Docker daemon attempts."
                    },
                    "always": {
                        name: "Always",
                        description: "Always restart the container regardless of the exit status. " +
                        "When you specify always, the Docker daemon will try to restart the container indefinitely. " +
                        "The container will also always start on daemon startup, regardless of the current state of the container."
                    },
                    "unless-stopped": {
                        name: "Unless Stopped",
                        description: "Always restart the container regardless of the exit status, but do not start it on daemon startup if the container has been put to a stopped state before."
                    }
                };

                if (!vm.action.Properties["Octopus.Action.Docker.RestartPolicy"]) {
                    vm.action.Properties["Octopus.Action.Docker.RestartPolicy"] = "no";
                }
            },
            summaryLink: function($scope, element) {
                return octopusRepository.Feeds.get($scope.properties["Octopus.Action.Package.FeedId"]).then(function(feed){
                    $scope.feedName = feed.Name;
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_run/Octopus.DockerRun.js
// module id = 7902296750597992
// module chunks = 1